// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"926":"d393b611","3660":"d393b611","4374":"11fd2386","6738":"cfc29411","8633":"795d5209","9988":"ac63609d"}[chunkId] + ".chunk.css";
};